import { arrow, autoUpdate, flip, FloatingArrow, FloatingPortal, inline, offset, shift, useDismiss, useFloating, useFocus, useHover, useInteractions, useRole, } from '@floating-ui/react';
import React, { useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../Box';
import { Text } from '../Text';
import { theme } from '../theme';
const tooltipVariants = {
    primary: {
        textColor: 'liquorice',
        bgColor: 'custard',
    },
    fallback: {
        textColor: 'cream',
        bgColor: 'feijoa',
    },
    bubblegum: {
        textColor: 'liquorice',
        bgColor: 'bubblegum',
    },
};
const ARROW_HEIGHT = 8;
const GAP = 4;
export const Tooltip = ({ children, title, content, position, maxWidth = 500, underline = false, portalContainer, inline: inlineProp, variant = 'primary', }) => {
    const [showTip, setShowTip] = useState(false);
    const arrowRef = useRef(null);
    const variantValue = tooltipVariants[variant];
    const randomId = crypto.randomUUID();
    const { refs, floatingStyles, context } = useFloating({
        open: showTip,
        placement: position,
        onOpenChange: setShowTip,
        middleware: [
            offset(ARROW_HEIGHT + GAP),
            flip(),
            shift(),
            inlineProp ? inline() : undefined,
            arrow({ element: arrowRef, padding: 14 }),
        ],
        whileElementsMounted: autoUpdate,
    });
    const hover = useHover(context, { move: false });
    const focus = useFocus(context);
    const dismiss = useDismiss(context);
    const role = useRole(context, { role: 'tooltip' });
    // Merge all the interactions into prop getters
    const { getReferenceProps, getFloatingProps } = useInteractions([
        hover,
        focus,
        dismiss,
        role,
    ]);
    return (React.createElement(React.Fragment, null,
        React.createElement(UnderlinedChild, { id: randomId, "$underline": underline, ref: refs.setReference, ...getReferenceProps() }, children),
        showTip && (React.createElement(FloatingPortal, { root: portalContainer },
            React.createElement(Tip, { ref: refs.setFloating, className: "tooltip", "$maxWidth": maxWidth, "$background": theme.colors[variantValue.bgColor], style: floatingStyles, ...getFloatingProps() },
                React.createElement(FloatingArrow, { ref: arrowRef, context: context, fill: theme.colors[variantValue.bgColor] }),
                title && (React.createElement(Text, { tag: "h5", typo: "headline-small", color: variantValue.textColor }, title)),
                (typeof content === 'string' && (React.createElement(Text, { typo: "body-regular", color: variantValue.textColor }, content))) ||
                    content)))));
};
const UnderlinedChild = styled(Box) `
  cursor: pointer;
  width: fit-content;
  display: inline-flex;

  ${({ $underline }) => $underline &&
    css `
      border-bottom: 1px dashed ${theme.colors.marshmallowPink};
    `}
`;
export const Tip = styled.div `
  position: absolute;
  margin: auto;
  z-index: 1000;
  background: ${({ $background }) => $background};
  padding: 16px 12px 20px;
  border-radius: 16px;
  max-width: 450px;
  pointer-events: none;
  cursor: default;

  // this is the trick that will make sure the content can go up to maxWidth
  margin-right: ${({ $maxWidth }) => $maxWidth && -$maxWidth / 2 + 'px'};
  max-width: ${({ $maxWidth }) => $maxWidth && $maxWidth + 'px'};
`;
//# sourceMappingURL=Tooltip.js.map